import Header from "../../layouts/AuthLayout/header/header";
import Footer from "../home/footer";
import BreadcrumbSection from "./breadcrumb-section";
import ShopSection from "./shop-section";

export default function ProductsPage() {
  return (
    <>
      <Header />
      <BreadcrumbSection />
      <ShopSection />
      <Footer />
    </>
  );
}
